export const CONSTANTS: {[index: string]: any} = {
    starHoverColor: '#D5001C',
    starColorDefault: '#EDEEEE' 
  }
  